import fetch from '../utils/fetch'

export function getVisitLst(query) {
  return fetch({
    url: '/visit/lst',
    method: 'get',
    params: query
  })
}
export function getXporders(query) {
  return fetch({
    url: '/xporders',
    method: 'get',
    params: query
  })
}
export function getVisitOrderdata(query) {
  return fetch({
    url: '/visit/orderdata',
    method: 'get',
    params: query
  })
}
